function queryString(request) {
  return Object.entries(request).reduce((acc, val) => `${acc}${val[0]}=${val[1]}&`, '?');
}

export default queryString;